module.exports = __webpack_public_path__ + "img/3.c07e2882.png";